<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        version="1.1"
        xmlns:dc="http://purl.org/dc/elements/1.1/" 
        xmlns:cc="http://creativecommons.org/ns#" 
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" 
        xmlns:svg="http://www.w3.org/2000/svg" 
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        sodipodi:docname="remove-circle.svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :width="iconWidth"
        :height="iconHeight"
        viewBox="0 0 1200 1200"
        enable-background="new 0 0 1200 1200"
        xml:space="preserve"
    >
        <path 
            inkscape:connector-curvature="0" 
            d="M600,0C268.63,0,0,268.63,0,600c0,331.369,268.63,600,600,600
            c331.369,0,600-268.63,600-600S931.369,0,600,0z M600,130.371c259.369,0,469.556,210.325,469.556,469.629
            c0,259.305-210.187,469.556-469.556,469.556c-259.37,0-469.556-210.251-469.556-469.556C130.445,340.696,340.63,130.371,600,130.371
            L600,130.371z M435.425,305.347L305.347,435.425L469.922,600L305.347,764.575l130.078,130.078L600,730.078l164.575,164.575
            l130.078-130.078L730.078,600l164.575-164.575L764.575,305.347L600,469.922L435.425,305.347z"
            fill="currentColor"
        />
    </svg>
</template>